import { useQuery } from "@tanstack/react-query"
import { useApi } from "../../../../hooks/useApi"
import { Order } from "../types/order"
import { AxiosError } from "axios"

const useOrderQuery = ({ orderId }: { orderId: string }) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery<Order, AxiosError>(
    ["order", orderId],
    () => scientApi.trading.getOrder(orderId),
    {
      staleTime: 0,
      refetchOnWindowFocus: false,
      enabled: !!orderId,
      retry: (failureCount, error) => {
        // Don't retry on 404 errors
        if (error?.response?.status === 404) return false
        // Retry other errors up to 3 times
        return failureCount < 3
      },
    },
  )

  return {
    order: data,
    isLoading,
    error,
  }
}

export default useOrderQuery
